import React, { useContext, useState } from "react";
import Layout from '../layout';
import AuthContext from "../../../context/AuthContext";
import { SIGNINFORM } from "../../../utils/data";
import SignInForm from './SigninForm';

function initialFormValues() {
  return {
    email: "",
    password: "",
  };
}

const SignIn = () => {
  const { signIn } = useContext(AuthContext);
  const [values, setValues] = useState(initialFormValues);
  const [spinnerBtn, setSpinnerBtn] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setValues({
      ...values,
      [name]: value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSpinnerBtn(true);
    const singInRes =  await signIn(values);
    if (singInRes) {
      setSpinnerBtn(singInRes);
    }else{
      setSpinnerBtn(singInRes);
    }
  };

  return (
    <>
    <Layout>
      
              {/* <span className="mb-1.5 block font-medium">Welcome</span> */}
              {/* <h2 className="mb-9 text-2xl font-bold text-center text-black dark:text-white sm:text-title-xl2">
                Sign In
              </h2> */}
              <SignInForm formFields={SIGNINFORM} handleChange={handleChange} handleSubmit={handleSubmit} spinnerBtn={spinnerBtn}/>
    </Layout>
    </>
  );
};

export default SignIn;
